<template>
    <div class="main">
        <div class="nav">
            <Nav :title="'面访记录'" :arrow="false"></Nav>
        </div>
        <div style="margin-bottom: 60px;">
            <kuhuList class="kuhuList" :name="'面访记录'" :clientlist="clientlist"></kuhuList>
        </div>
        <div class="footer">
            <fooalt :active="1"></fooalt>
        </div>
    </div>
</template>

<script>
import Nav from './component/nav.vue';
import fooalt from './component/fooalt.vue';
import kuhuList from './component/kuhuList.vue';
import { qiweiAPI } from '../../../api/qiwei.js';
export default {
    data() {
        return {
            clientlist:[] 
        }
    },
    mounted() {
        this.KeLeShouSignInList({
            page: '1',
            qw_user_id: this.$t.qiwei_yuangong_num,
            limit: '100',
        })
    },
    methods: {
        onClick(index) {
            console.log(index);
        },
        KeLeShouSignInList(params) {
            this.$axios
                .get(qiweiAPI.KeLeShouSignInList, {
                    params,
                  headers: this.$t.headers,
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.show = false
                        this.clientlist = res.data.data.data

                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        }
    },
    components: {
        Nav,
        kuhuList,
        fooalt
    }
}
</script>

<style>
.main {
    width: 100%;
}
.kuhuList{
    margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/keleshou/interviewinglog.vue